// Import React
import React from "react";

// Import the custom hook
import usePodDesignAiFlow from "./hooks/usePodDesignAiFlow";

// Import the prompt form component
import PodDesignAiPromptForm from "./components/PodDesignAiPromptForm";

// Import page CSS
import "./PodDesignAiPage.css";



// Export the main page component
export default function PodDesignAiPage({
    setSubmittedAiDesign,
    setShowPodDesignAiPage,
}) {

    // Get the flow state and handlers from the custom hook
    const {
        currentStep,
        prompt,
        setPrompt,
        title,
        setTitle,
        designType,
        setDesignType,
        selectedModelId,
        setSelectedModelId,
        selectedStyleId,
        setSelectedStyleId,
        tagDescribeMode,
        setTagDescribeMode,
        selectedAspectRatio,
        setSelectedAspectRatio,
        modelOptions,
        styleOptions,
        aspectRatioOptions,
        designTypeOptions,
        tagDescribeOptions,
        generatedImage,
        optimisedImage,
        isGenerating,
        isOptimising,
        isLoadingSetupData,
        generateError,
        setupError,
        canGenerate,
        canOptimise,
        canSubmit,
        handleGenerateImage,
        handleResetImageSettings,
        handleOptimiseImage,
        handleSubmitDesign,
        previewBackgroundColours,
        formSettingsMatchImageSettings,
        
    } = usePodDesignAiFlow({
        setSubmittedAiDesign,
        setShowPodDesignAiPage,
    });



    // Return the page UI
    return (

        <div className="podDesignAiPage">

            {/* This is the main card */}
            <div className="podDesignAiPage__card">

                {/* This is the page body */}
                <div className="podDesignAiPage__body">

                    {/* This is step 1: Generate */}
                    {

                    (currentStep === "generate" || currentStep === "generating" || currentStep === "optimise" || currentStep === "optimising" || currentStep === "review" ) && (

                        <PodDesignAiPromptForm
                            prompt={prompt}
                            setPrompt={setPrompt}
                            title={title}
                            setTitle={setTitle}
                            designType={designType}
                            setDesignType={setDesignType}
                            selectedModelId={selectedModelId}
                            setSelectedModelId={setSelectedModelId}
                            selectedStyleId={selectedStyleId}
                            setSelectedStyleId={setSelectedStyleId}
                            tagDescribeMode={tagDescribeMode}
                            setTagDescribeMode={setTagDescribeMode}
                            selectedAspectRatio={selectedAspectRatio}
                            setSelectedAspectRatio={setSelectedAspectRatio}
                            modelOptions={modelOptions}
                            styleOptions={styleOptions}
                            aspectRatioOptions={aspectRatioOptions}
                            designTypeOptions={designTypeOptions}
                            tagDescribeOptions={tagDescribeOptions}
                            onGenerate={handleGenerateImage}
                            onReset={handleResetImageSettings}
                            onOptimise={handleOptimiseImage}
                            isOptimising={isOptimising}
                            canGenerate={canGenerate}
                            isGenerating={isGenerating}
                            canOptimise={canOptimise}
                            isLoadingSetupData={isLoadingSetupData}
                            generateError={generateError}
                            setupError={setupError}
                            currentStep={currentStep}
                            generatedImage={generatedImage}
                            optimisedImage={optimisedImage}
                            previewBackgroundColours={previewBackgroundColours}
                            formSettingsMatchImageSettings={formSettingsMatchImageSettings}
                            handleSubmitDesign={handleSubmitDesign}
                            canSubmit={canSubmit}
                        />

                    )}

                </div>

            </div>

        </div>
    );
}